import { SapBwCubeDataset } from 'app/model/dataset/sap-bw-cube.dataset';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.sapBw.copySourceType,
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(SapBwCubeDataset)
    }
})
export class SapBwCopySource extends TabularCopySource {
}
